import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useDashboardId } from './use-dashboard-id';

export const useBackRedirect = () => {
  const navigate = useNavigate();
  const cachedData = useDashboardId();

  const defaultDashboardId = cachedData?.dashboardId || (cachedData?.dashboards && cachedData?.dashboards?.[0]?.id);

  useEffect(() => {
    const handlePopState = () => {
      const currentSearch = new URLSearchParams(window.location.search);
      const dashboardId = currentSearch.get('dashboardId');

      if (!dashboardId) {
        navigate(`/main/dashboard?dashboardId=${defaultDashboardId}`, { replace: true });
      }
    };

    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [navigate, defaultDashboardId]);
};
